import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AlertService } from '@services/alert.service';
import { UPLOAD_STATUS } from '@public/make-payment/payment-request/payment-request-v1.component';

@Component({
  selector: 'ew-upload-proof-of-payment',
  templateUrl: './upload-proof-of-payment.component.html',
  styleUrls: ['./upload-proof-of-payment.component.scss'],
})
export class UploadProofOfPaymentComponent {
  @Input() label: string = 'upload file';
  @Input() expirationDate: string = '';
  @Input() status: UPLOAD_STATUS = UPLOAD_STATUS.Pending;
  @Input() width: string = '160px';
  @Input() file: any;
  @Input() required: boolean = false;
  @Input() acceptedTypes?: any[];
  @Input() maxSize?: number;
  @Input() loading?: boolean = false;

  @Output() valueChanged$ = new EventEmitter<any>();

  error!: string;

  constructor(private alertService: AlertService) {}
  // Define allowed file types
  private readonly ALLOWED_FILE_TYPES = [
    'image/jpeg',
    'image/png',
    'image/webp',
    'image/svg+xml',
    'application/pdf',
  ];

  get displayUploadButton() {
    if (this.isPending) {
      return true;
    }

    return false;
  }

  get isPending() {
    return this.status === UPLOAD_STATUS.Pending;
  }

  /**
   * prepare file to send to EP
   * @param event event input file
   * @author Martin Batun Tec.
   */
  send(event?: any): void {
    const file = event.target.files[0];

    // Validate file before processing
    if (!this.validateFile(file)) {
      // Clear the input to allow re-selection of the same file
      this.alertService.error('uploadProofOfPayment:invalidFileType', file);
      event.target.value = '';
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = (_event) => {
      this.valueChanged$.emit({
        name: file.name,
        size: file.size,
        mimeType: file.type,
        file: file,
        url: reader.result,
        valid: true, // We already validated above
        ref: this.label,
        key:
          this.label === 'paymentRequest:proofOfPayment'
            ? 'proofOfPayment'
            : '', // Adiciona a chave
      });
    };
  }

  delete(): void {
    this.file = null;
    this.valueChanged$.emit(null);
    this.error = '';
  }

  validateFile(file: File): boolean {
    // Always enforce allowed file types
    const allowedTypes = this.acceptedTypes || this.ALLOWED_FILE_TYPES;
    if (!allowedTypes.includes(file.type)) {
      this.error = 'shared:fileValidationType';
      return false;
    }

    if (this.maxSize && this.maxSize < file.size) {
      this.error = 'shared:fileValidationSize';
      return false;
    }

    return true;
  }

  getAcceptedFileTypes() {
    const types = this.acceptedTypes || this.ALLOWED_FILE_TYPES;
    return types.join(',');
  }
}

export type FileType = {
  name: string;
  size: number;
  mimeType: string;
  file: File;
  url: string;
  valid: boolean;
};
